/** Indicate what mode the page is currently in. Will determine behavior and rendering of components. */
export enum Mode {
   Create,
   Edit,
   Delete,
   Readonly,
}
